const baseAction = "REVIEWS";

export function CreateReviewCycle(payload, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.CREATE`, payload, callback });
	};
}

export function ValidateReviewCycleFields(payload, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.VALIDATE`, payload, callback });
	};
}

export function CycleGet(cycleId, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.GET`, cycleId, callback });
	};
}

export function CycleAddUsers(cycleId, payload, callback) {
	return (dispatch) => {
		/*
            payload: { startDate, userSelectionId }
        */

		dispatch({
			type: `${baseAction}:CYCLE.ADD_USERS`,
			cycleId,
			payload,
			callback,
		});
	};
}

export function CycleGetProgress(cycleId, functionName, callback) {
	return (dispatch) => {
		/*
            The function names are: overall|form|authors|signers|meta
        */

		dispatch({
			type: `${baseAction}:CYCLE.PROGRESS`,
			cycleId,
			functionName,
			callback,
		});
	};
}

export function CycleFilterReviews(cycleId, payload, callback) {
	return (dispatch) => {
		dispatch({
			type: `${baseAction}:CYCLE.FILTER`,
			cycleId,
			payload,
			callback,
		});
	};
}

export function DeleteReviewCycle(cycleId, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.DELETE`, cycleId, callback });
	};
}

export function CloseReviewCycle(cycleId, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.CLOSE`, cycleId, callback });
	};
}

export function EditReviewCycle(cycleId, payload, callback) {
	return (dispatch) => {
		dispatch({
			type: `${baseAction}:CYCLE.EDIT`,
			cycleId,
			payload,
			callback,
		});
	};
}

export function GetReviewCycleExclusionList(cycleId, callback) {
	return (dispatch) => {
		dispatch({
			type: `${baseAction}:CYCLE.GET_EXCLUSION_LIST`,
			cycleId,
			callback,
		});
	};
}

export function GetReviewCycleDetails(cycleId, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.DETAILS`, cycleId, callback });
	};
}

export function AddEasyAdd(cycleId, payload, callback) {
	return (dispatch) => {
		dispatch({ type: `${baseAction}:CYCLE.ADD_EASY_ADD` }, cycleId, payload, callback);
	};
}

export function BulkEasyAddsDeactivate(cycleId, payload, callback) {
	return (dispatch) => {
		dispatch({ type: `REVIEW:CYCLE.EASY_ADDS_BULK_DEACTIVATE` }, cycleId, payload, callback);
	};
}
